/**
 * Filtra el grid por término de búsqueda y por colección.
 * Opera sobre productos ya cargados en la página actual.
 */
(function () {
  function normalize(str) {
    return (str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }


  function getRequestedCollection() {
    var params = new URLSearchParams(window.location.search);
    return normalize(params.get('collection'));
  }

  function updateCollectionQuery(handle) {
    var url = new URL(window.location.href);
    if (handle) {
      url.searchParams.set('collection', handle);
    } else {
      url.searchParams.delete('collection');
    }
    window.history.replaceState({}, '', url.toString());
  }

  function toNumber(value) {
    var n = Number(value);
    return Number.isNaN(n) ? 0 : n;
  }

  function sortGrid(root, sortValue) {
    var list = root.querySelector('#product-grid');
    if (!list) return;

    var items = Array.prototype.slice.call(list.querySelectorAll('.s-product-grid__item'));
    if (!items.length) return;

    var compare;
    switch (sortValue) {
      case 'title-ascending':
        compare = function (a, b) {
          return (a.getAttribute('data-grid-title') || '').localeCompare(b.getAttribute('data-grid-title') || '');
        };
        break;
      case 'title-descending':
        compare = function (a, b) {
          return (b.getAttribute('data-grid-title') || '').localeCompare(a.getAttribute('data-grid-title') || '');
        };
        break;
      case 'price-ascending':
        compare = function (a, b) {
          return toNumber(a.getAttribute('data-grid-price')) - toNumber(b.getAttribute('data-grid-price'));
        };
        break;
      case 'price-descending':
        compare = function (a, b) {
          return toNumber(b.getAttribute('data-grid-price')) - toNumber(a.getAttribute('data-grid-price'));
        };
        break;
      case 'created-ascending':
        compare = function (a, b) {
          return toNumber(a.getAttribute('data-grid-created-at')) - toNumber(b.getAttribute('data-grid-created-at'));
        };
        break;
      case 'created-descending':
        compare = function (a, b) {
          return toNumber(b.getAttribute('data-grid-created-at')) - toNumber(a.getAttribute('data-grid-created-at'));
        };
        break;
      default:
        compare = function (a, b) {
          return toNumber(a.getAttribute('data-grid-order')) - toNumber(b.getAttribute('data-grid-order'));
        };
        break;
    }

    items.sort(compare);
    for (var i = 0; i < items.length; i++) {
      list.appendChild(items[i]);
    }
  }

  function removeBestSellingFromSorts(root) {
    var selects = root.querySelectorAll('select[name="sort_by"]');
    for (var i = 0; i < selects.length; i++) {
      var select = selects[i];
      var options = select.querySelectorAll('option');
      for (var j = options.length - 1; j >= 0; j--) {
        if (normalize(options[j].value) === 'best-selling') {
          options[j].remove();
        }
      }

      if (normalize(select.value) === 'best-selling' && select.options.length) {
        select.selectedIndex = 0;
      }
    }
  }

  function removeCollectionFacet(root) {
    var facetSummaries = root.querySelectorAll(
      '.facets__disclosure-vertical .facets__summary, .facets__disclosure .facets__summary, .mobile-facets__details .mobile-facets__summary'
    );
    for (var i = 0; i < facetSummaries.length; i++) {
      var summary = facetSummaries[i];
      var text = normalize(summary.textContent);
      if (text.indexOf('colección') !== -1 || text.indexOf('collection') !== -1) {
        var facetBlock =
          summary.closest('.facets__disclosure-vertical') ||
          summary.closest('.facets__disclosure') ||
          summary.closest('.mobile-facets__details');
        if (facetBlock) facetBlock.remove();
      }
    }
  }

  function initFiltersToggle(root) {
    var toggle = root.querySelector('[data-filters-toggle]');
    if (!toggle) return;
    var mobileDrawer = root.querySelector('.mobile-facets__wrapper');
    var mobileDrawerDetails = mobileDrawer ? mobileDrawer.querySelector('.mobile-facets__disclosure') : null;
    var mobileApplyButton = root.querySelector('[data-mobile-filters-apply]');
    var productGridContainer = root.querySelector('#ProductGridContainer');

    var isMobile = function () {
      return window.matchMedia('(max-width: 808px)').matches;
    };

    var setMobileOpen = function (open) {
      root.classList.toggle('mobile-filters-open', open);
      if (mobileDrawerDetails) {
        if (open) {
          mobileDrawerDetails.setAttribute('open', '');
        } else {
          mobileDrawerDetails.removeAttribute('open');
        }
      }
    };

    var setExpanded = function (expanded) {
      root.classList.toggle('filters-collapsed', !expanded);
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    };

    setExpanded(false);
    if (isMobile()) setMobileOpen(false);
    toggle.addEventListener('click', function () {
      if (isMobile()) {
        var isOpen = root.classList.contains('mobile-filters-open');
        setMobileOpen(!isOpen);
        return;
      }
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      setExpanded(!expanded);
    });

    window.addEventListener('resize', function () {
      if (!isMobile()) {
        setMobileOpen(false);
      }
    });

    if (mobileApplyButton) {
      mobileApplyButton.addEventListener('click', function () {
        if (!isMobile()) return;
        setMobileOpen(false);
        if (productGridContainer) {
          window.requestAnimationFrame(function () {
            productGridContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }
      });
    }
  }

  function initActiveFiltersState(root) {
    var setState = function () {
      var activeFilterPills = root.querySelectorAll('.active-facets .active-facets__button');
      root.classList.toggle('has-active-filters', activeFilterPills.length > 0);
    };

    setState();

    var observer = new MutationObserver(function () {
      setState();
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  function initGridViewToggle(root) {
    var viewButtons = root.querySelectorAll('[data-grid-view-toggle]');
    if (!viewButtons.length) return;

    var storageKey = 'collection-grid-view';
    var isMobile = function () {
      return window.matchMedia('(max-width: 808px)').matches;
    };

    function setView(view) {
      var nextView = view === 'list' ? 'list' : 'grid';
      root.setAttribute('data-grid-view', nextView);

      for (var i = 0; i < viewButtons.length; i++) {
        var button = viewButtons[i];
        var isActive = button.getAttribute('data-grid-view-toggle') === nextView;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }
    }

    var savedView = null;
    try {
      savedView = window.localStorage.getItem(storageKey);
    } catch (e) {
      savedView = null;
    }

    var initialView;
    if (isMobile()) {
      // En mobile siempre arrancamos en lista, ignorando preferencias previas.
      initialView = 'list';
    } else if (savedView === 'list' || savedView === 'grid') {
      initialView = savedView;
    } else {
      initialView = 'grid';
    }

    setView(initialView);

    for (var j = 0; j < viewButtons.length; j++) {
      viewButtons[j].addEventListener('click', function () {
        var selectedView = this.getAttribute('data-grid-view-toggle') || 'grid';
        setView(selectedView);
        try {
          window.localStorage.setItem(storageKey, selectedView);
        } catch (e) {
          // No action needed if storage is not available.
        }
      });
    }
  }

  function getSearchBlob(item) {
    var cached = item.__gridSearchBlob;
    if (cached) return cached;
    var raw = item.getAttribute('data-grid-search-text') || '';
    cached = normalize(raw);
    item.__gridSearchBlob = cached;
    return cached;
  }

  function applyFilter(root) {
    var input = root.querySelector('.js-collection-grid-search');
    var list = root.querySelector('#product-grid');
    if (!input || !list) return;

    var selectedHandle = normalize(root.getAttribute('data-selected-collection') || '');
    var items = list.querySelectorAll('.s-product-grid__item');
    var emptyNote = root.querySelector('.js-collection-grid-filter-empty');
    var pagination = root.querySelector('.pagination-wrapper');

    var q = normalize(input.value);
    var tokens = q ? q.split(/\s+/).filter(Boolean) : [];
    var visible = 0;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var blob = getSearchBlob(item);
      var collections = normalize(item.getAttribute('data-grid-collections') || '');

      var matchQuery = true;
      for (var t = 0; t < tokens.length; t++) {
        if (blob.indexOf(tokens[t]) === -1) {
          matchQuery = false;
          break;
        }
      }
      var matchCollection = !selectedHandle || collections.indexOf(selectedHandle + ',') !== -1;

      if (matchQuery && matchCollection) {
        item.hidden = false;
        visible++;
      } else {
        item.hidden = true;
      }
    }

    if (emptyNote) emptyNote.hidden = visible !== 0;
    if (pagination) pagination.hidden = Boolean(q || selectedHandle);
  }

  function setActiveChip(root, handle) {
    var chips = root.querySelectorAll('.js-collection-filter-chip');
    for (var i = 0; i < chips.length; i++) {
      var chip = chips[i];
      var chipHandle = normalize(chip.getAttribute('data-collection-filter') || '');
      var isActive = chipHandle === handle;
      chip.classList.toggle('is-active', isActive);
      chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }
    root.setAttribute('data-selected-collection', handle);
  }

  function initRoot(root) {
    var input = root.querySelector('.js-collection-grid-search');
    if (!input) return;

    var form = root.querySelector('[data-collection-grid-filter-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
      });
    }

    initFiltersToggle(root);
    initActiveFiltersState(root);
    initGridViewToggle(root);
    removeBestSellingFromSorts(root);
    removeCollectionFacet(root);

    var requestedHandle = getRequestedCollection();
    setActiveChip(root, requestedHandle);

    var chips = root.querySelectorAll('.js-collection-filter-chip');
    for (var i = 0; i < chips.length; i++) {
      chips[i].addEventListener('click', function () {
        var handle = normalize(this.getAttribute('data-collection-filter') || '');
        setActiveChip(root, handle);
        updateCollectionQuery(handle);
        applyFilter(root);
      });
    }

    input.addEventListener('input', function () {
      applyFilter(root);
    });

    var sortSelect = root.querySelector('.js-collection-inline-sort');
    var sortForm = root.querySelector('#CollectionsHubSortForm');
    var updateSortSelectWidth = function () {
      if (!sortSelect || !sortSelect.options || sortSelect.selectedIndex < 0) return;
      var selectedOption = sortSelect.options[sortSelect.selectedIndex];
      var label = selectedOption ? selectedOption.textContent || '' : '';
      // Ajusta el ancho al texto seleccionado (más un pequeño buffer visual).
      sortSelect.style.width = Math.max(6, label.trim().length + 2) + 'ch';
    };
    if (sortForm) {
      sortForm.addEventListener('submit', function (e) {
        e.preventDefault();
      });
    }
    if (sortSelect) {
      sortSelect.addEventListener(
        'change',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
          updateSortSelectWidth();
          sortGrid(root, sortSelect.value);
        },
        true
      );
      updateSortSelectWidth();
      sortGrid(root, sortSelect.value);
    }

    applyFilter(root);
  }

  function run() {
    var roots = document.querySelectorAll('[data-collection-page-root]');
    for (var r = 0; r < roots.length; r++) {
      initRoot(roots[r]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

